function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_24_139)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.459 0L7.6367 5.36328C7.44529 5.72031 7.06717 5.78281 6.68553 5.87891C5.00115 6.30312 1.991 5.67695 1.20584 6.00117C0.521857 6.28359 0.0499821 8.45078 0.394904 8.92695C1.06014 9.83281 4.93279 9.21094 6.13006 8.99375C6.56649 8.91626 6.98887 8.77393 7.38318 8.57148C7.86678 8.32109 8.41639 7.925 8.68162 7.34336C8.93865 6.78281 10.5832 3.37969 12.2203 0H10.459Z",
  fill: "#5A5F63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4594 0L7.94531 4.77852L9.67578 5.26445C10.3559 3.85313 11.2898 1.92305 12.2211 0H10.4594Z",
  fill: "#E24B4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.70864 5.87305L6.6852 5.87891C5.35356 6.21406 3.19731 5.89453 1.96294 5.90547C1.3688 7.11719 1.01333 8.25859 1.0563 9.28398C2.29341 9.58906 4.71762 9.2375 5.85864 9.04102C6.25669 8.08789 6.51801 7.01211 6.70864 5.87305Z",
  fill: "#E9EFF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.25671 9.13873C5.61272 8.10927 5.88957 7.05412 6.08484 5.98248C6.03445 5.98834 5.98289 5.99342 5.93132 5.99772C5.73793 7.07265 5.46038 8.13072 5.10125 9.16217L5.25671 9.13873ZM2.57976 5.92037C2.52937 5.91803 2.47898 5.91569 2.43015 5.91412C2.02754 7.03539 1.72059 8.18873 1.51257 9.36178C1.56101 9.36725 1.61023 9.37194 1.66062 9.37662C1.86792 8.20045 2.17542 7.04415 2.57976 5.92037ZM3.96609 5.9985L3.82 5.9903C3.42795 7.09593 3.12861 8.23227 2.92507 9.38756L3.07742 9.37936C3.27995 8.22984 3.57719 7.09903 3.96609 5.9985ZM3.27312 5.95826L3.1282 5.94967C2.72766 7.07327 2.42152 8.22831 2.21296 9.4028H2.36296C2.56837 8.23094 2.87284 7.07863 3.27312 5.95826ZM5.42625 6.02662C5.37625 6.02819 5.32703 6.02975 5.27625 6.03053C5.06726 6.68365 4.70164 7.83991 4.38914 9.25787L4.54226 9.23873C4.85359 7.82545 5.21687 6.6735 5.42625 6.02662ZM4.71453 6.0274L4.56648 6.02389C4.21473 7.11291 3.91452 8.21791 3.66687 9.33522L3.81882 9.32155C4.13523 7.87467 4.50125 6.69576 4.71453 6.0274Z",
  fill: "#DEE4E9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8598 11.7633C10.8598 12.1703 9.88868 12.5 8.69103 12.5C7.49337 12.5 6.52228 12.1703 6.52228 11.7633V10.6285C6.52228 10.2215 7.49337 9.89178 8.69103 9.89178C9.88868 9.89178 10.8598 10.2215 10.8598 10.6285V11.7633Z",
  fill: "#5A5F63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.73785 10.6004V12.4086C9.95971 12.3699 10.1768 12.3077 10.3855 12.2231V10.6004H9.73785ZM10.5812 10.5051V12.1238C10.6214 12.0996 10.6562 12.0742 10.6886 12.0484V10.5047L10.5812 10.5051Z",
  fill: "#E9EFF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.69103 11.3652C9.8888 11.3652 10.8598 11.0354 10.8598 10.6285C10.8598 10.2216 9.8888 9.89178 8.69103 9.89178C7.49326 9.89178 6.52228 10.2216 6.52228 10.6285C6.52228 11.0354 7.49326 11.3652 8.69103 11.3652Z",
  fill: "#E9EFF4"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_24_139"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.5,
  height: 12.5,
  fill: "white"
})));

var SvgIceHockey = function SvgIceHockey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIceHockey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ice-hockey.014ae8bc.svg";
export { ForwardRef as ReactComponent };